import { Link } from 'react-router-dom';

const BG = '#0c0a12';

const navLink = (to, text) => (
  <Link
    to={to}
    className="text-white/90 underline-offset-2 transition-colors hover:text-white hover:underline"
  >
    {text}
  </Link>
);

/** AERTA+ — violet spotlight on this page */
export const PIPELINE_BENTO_GLOW = '132, 0, 255';

export const PIPELINE_BENTO_CARDS = [
  {
    color: BG,
    title: 'Six-phase engagement',
    description: 'Recon through remediation with human gates before sensitive steps.',
    label: 'Phases',
  },
  {
    color: BG,
    title: 'Approvals on the record',
    description: 'Critical transitions require explicit sign-off; AERTA stores the audit trail.',
    label: 'Gates',
  },
  {
    color: BG,
    title: 'CypherFix & graph triage',
    description: 'Query-assisted fixes and Neo4j-backed context for analyst workflows.',
    label: 'CypherFix',
  },
  {
    color: BG,
    title: 'Executor & allowlist',
    description: 'Allowlisted nmap profiles; optional AERTAX bridge to Docker Kali.',
    label: 'Executor',
  },
  {
    color: BG,
    title: 'Engagement vs demo',
    description: 'Engagement pulls real Layer 1 risk; demo uses synthetic placeholders only.',
    label: 'Modes',
  },
  {
    color: BG,
    title: 'Graph findings',
    description: 'Synced findings surface under Graph — explore without a separate console.',
    label: navLink('/graph-findings', 'Graph'),
  },
];

/** Graph page — cyan, no document spotlight (busy viz + aurora) */
export const GRAPH_BENTO_GLOW = '14, 165, 233';

export const GRAPH_BENTO_CARDS = [
  {
    color: BG,
    title: 'Live property graph',
    description: 'Pan, zoom, and inspect nodes synced from the pipeline into Neo4j.',
    label: 'Viz',
  },
  {
    color: BG,
    title: 'Nodes & relationships',
    description: 'Assets, findings, and edges tie evidence across your environment.',
    label: 'Model',
  },
  {
    color: BG,
    title: 'Severity filters',
    description: 'Slice the table by criticality; summary counts stay in sync.',
    label: 'Filter',
  },
  {
    color: BG,
    title: 'No extra console',
    description: 'Explore linked data in-app — URI comes from server configuration.',
    label: 'Neo4j',
  },
  {
    color: BG,
    title: 'Pipeline-fed',
    description: 'Autonomous pipeline sync keeps the graph aligned with latest runs.',
    label: navLink('/autonomous-pipeline', 'Autonomous pipeline'),
  },
  {
    color: BG,
    title: 'Executor artifacts',
    description: 'Port scans and host evidence complement graph-native findings.',
    label: navLink('/runs', 'Runs'),
  },
];

/** Executor runs — amber */
export const RUNS_BENTO_GLOW = '245, 158, 11';

export const RUNS_BENTO_CARDS = [
  {
    color: BG,
    title: 'Allowlisted targets',
    description: 'Only IPs/CIDRs in AERTA_SCAN_ALLOWLIST — same contract as network scan.',
    label: 'Scope',
  },
  {
    color: BG,
    title: 'Profiles',
    description: 'nmap_tcp_default, top ports, service detection — pick per engagement.',
    label: 'Profiles',
  },
  {
    color: BG,
    title: 'Backend visibility',
    description: 'Local executor or AERTAX bridge; status shows in the pipeline card.',
    label: 'Bridge',
  },
  {
    color: BG,
    title: 'Deep links',
    description: 'Every run opens a detail page with hosts, ports, and raw context.',
    label: 'Drill-down',
  },
  {
    color: BG,
    title: 'Graph correlation',
    description: 'Cross-check open services against findings in Neo4j.',
    label: navLink('/graph-findings', 'Graph'),
  },
  {
    color: BG,
    title: 'Verification chain',
    description: 'Tie scans back to discovery → risk → attestation.',
    label: navLink('/verification-loop', 'Proof'),
  },
];

/** Verified fix loop — emerald */
export const VERIFICATION_BENTO_GLOW = '52, 211, 153';

export const VERIFICATION_BENTO_CARDS = [
  {
    color: BG,
    title: 'Discovery & inventory',
    description: 'Layer 1 evidence anchors everything downstream in the pilot.',
    label: 'Discover',
  },
  {
    color: BG,
    title: 'Risk & scenarios',
    description: 'CVEs, blast radius, and scenario context for prioritization.',
    label: navLink('/risk', 'Risk'),
  },
  {
    color: BG,
    title: 'Attack paths',
    description: 'Simulated paths from exposure to impact for OT and IT alignment.',
    label: 'Paths',
  },
  {
    color: BG,
    title: 'Remediation',
    description: 'Tracked fixes and evolution steps with owner visibility.',
    label: navLink('/remediation', 'Fix'),
  },
  {
    color: BG,
    title: 'Resimulation',
    description: 'Re-validate posture after changes land in the environment.',
    label: navLink('/resimulation', 'Resim'),
  },
  {
    color: BG,
    title: 'Compliance & attest',
    description: 'Control mapping and auditor-ready narrative for GRC.',
    label: navLink('/compliance', 'Trust'),
  },
];
